import { createSelector } from "redux-starter-kit";

export default createSelector(
  ["factoring.sendNOA"],
  payload => payload
);
